import { usePodConversationsSummary } from "@app/hooks/conversations";
import { getPodRoute } from "@app/lib/utils/router";

export function useMemoairSupportRoute({
  workspaceId,
  disabled,
}: {
  workspaceId: string;
  disabled?: boolean;
}): string | null {
  const { summary } = usePodConversationsSummary({
    workspaceId,
    options: { disabled: disabled ?? false },
  });
  const supportProject = summary.find(
    ({ space }) => space.systemKind === "memoair_support"
  );
  return supportProject
    ? getPodRoute(workspaceId, supportProject.space.sId)
    : null;
}
